import { render } from "./ElIcons.vue?vue&type=template&id=516b9f3b"
import script from "./ElIcons.vue?vue&type=script&lang=js"
export * from "./ElIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__